import { loadingBarReducer } from "react-redux-loading-bar";
import { connectRouter } from "connected-react-router";
import assetReducer from "reducers/asset";
import assetModalReducer from "reducers/asset_modal";
import assetUsers from "reducers/asset_users";
import assetAttachments from "reducers/assetAttachment";
import assetContacts from "reducers/assetContact";
import assetDeals from "reducers/assetDeal";
import assetIncentives from "reducers/assetIncentive";
import assetLeads from "reducers/assetLead";
import assetLeadContacts from "reducers/assetLeadContact";
import assetPictures from "reducers/assetPicture";
import brokerInviteModalReducer from "reducers/broker_invite_modal";
import channelReducer from "reducers/channel";
import companyReducer from "reducers/company";
import companyAccessRequest from "reducers/companyAccessRequest";
import companyUserReducer from "reducers/companyUser";
import dealReducer from "reducers/deal";
import dealModalReducer from "reducers/deal_modal";
import dealStageAssetReducer from "reducers/dealStageAsset";
import eventReducer from "reducers/event";
import floorplanReducer from "reducers/floorplan";
import floorplanSpaceReducer from "reducers/floorplanSpace";
import flyer from "reducers/flyer";
import incentives from "reducers/incentive";
import integrationsReducer from "reducers/integration";
import loadingReducer from "reducers/loading";
import modals from "reducers/modals";
import notificationReducer from "reducers/notification";
import portfolioReducer from "reducers/portfolio";
import postReducer from "reducers/post";
import proposal from "reducers/proposal";
import publicReducer from "reducers/public";
import regionReducer from "reducers/region";
import sidebarReducer from "reducers/sidebar";
import spaceReducer from "reducers/space";
import spaceModal from "reducers/spaceModal";
import subscription from "reducers/subscription";
import tenantReducer from "reducers/tenant";
import tenantContactReducer from "reducers/tenant_contact";
import termsOfServiceReducer from "reducers/termsOfService";
import userReducer from "reducers/user";

import { combineReducers, history } from "utils";

export default combineReducers({
  assetAttachments,
  assetIncentives,
  assetDeals,
  assetLeads,
  assetModal: assetModalReducer,
  assetPictures,
  assets: assetReducer,
  assetUsers,
  BrokerInviteModal: brokerInviteModalReducer,
  channel: channelReducer,
  company: companyReducer,
  companyAccessRequest,
  companyUser: companyUserReducer,
  assetLeadContacts,
  assetContacts,
  dealModal: dealModalReducer,
  deals: dealReducer,
  dealStageAssets: dealStageAssetReducer,
  event: eventReducer,
  floorplans: floorplanReducer,
  floorplanSpaces: floorplanSpaceReducer,
  flyer,
  incentives,
  integrations: integrationsReducer,
  loading: loadingReducer,
  loadingBar: loadingBarReducer,
  modals,
  notification: notificationReducer,
  portfolio: portfolioReducer,
  post: postReducer,
  proposal,
  public: publicReducer,
  region: regionReducer,
  router: connectRouter(history),
  sidebar: sidebarReducer,
  space: spaceReducer,
  spaceModal,
  subscription,
  tenant: tenantReducer,
  tenantContact: tenantContactReducer,
  termsOfService: termsOfServiceReducer,
  user: userReducer,
});
